import { SurveyTemplatesViewContainer } from '@hotjar/feedback';
import { Route } from 'react-router-dom';
import {
  ErrorBoundaryRoute,
  NoAppInterfaceRoute,
  SiteAccessRequiredRoute,
} from '@hotjar/webapp-routing';
import { SURVEY_TEMPLATES } from '@hotjar/webapp/constants/routes';

export const SurveyTemplateRoutes = (currentSiteId: string | null): JSX.Element | null => {
  if (currentSiteId === null) return null;
  return (
    <Route
      path={SURVEY_TEMPLATES.BASE.path}
      element={
        <SiteAccessRequiredRoute>
          <NoAppInterfaceRoute>
            <ErrorBoundaryRoute squadSentryTag="feedback" featureName="surveys.templates">
              <SurveyTemplatesViewContainer />
            </ErrorBoundaryRoute>
          </NoAppInterfaceRoute>
        </SiteAccessRequiredRoute>
      }
    />
  );
};
